import { useApiMutation } from '../../../../hooks/useApi';
import { workspaceService } from '../../../../services/workspaceService';
import type { InviteMembersRequest, InviteMembersResponse } from '../../../../services/workspaceService';

interface UseInviteMembersOptions {
  workspaceId: string | null;
  onSuccess?: (data: InviteMembersResponse) => void;
  onError?: (error: unknown) => void;
}

export function useInviteMembers({ workspaceId, onSuccess, onError }: UseInviteMembersOptions) {
  return useApiMutation<InviteMembersResponse, InviteMembersRequest>({
    mutationFn: (data) => {
      if (!workspaceId) {
        return Promise.reject(new Error('No workspace selected.'));
      }
      return workspaceService.inviteMembers(workspaceId, data);
    },
    invalidateKeys: workspaceId ? [['workspace-members', workspaceId]] : [],
    showSuccessToast: false, // We handle success UI in the modal
    showErrorToast: true,
    errorMessage: 'Failed to send invitations.',
    onSuccess,
    onError,
  });
}